import { useGetUserInfoQuery } from "../../../app/rootReducer";
import { LanguageInterface } from "../../interfaces/shared/LanguageInterface";
import { TranslationsInterface } from "../../interfaces/shared/TranslationsInterface";
import { TranslateFn, useStringTranslation } from "../useStringTranslation";

export interface UseProductDetailSessionResult {
    translationsLoaded: boolean;
    t: TranslateFn;
    translations: TranslationsInterface | undefined;
    activeLanguage: LanguageInterface | null;
    activeCountryId: number | undefined;
    userData: ReturnType<typeof useGetUserInfoQuery>;
    communicationEmail: string | null;
    isUserPending: boolean;
}

/** User + translations state shared by product range and refurbished detail pages. */
export const useProductDetailSession = (): UseProductDetailSessionResult => {
    const userData = useGetUserInfoQuery();
    const {
        t,
        translations,
        isLoading: isTranslationsLoading,
        isFetching: isTranslationsFetching,
    } = useStringTranslation();
    const activeLanguage = userData?.data?.activeLanguage ?? null;
    const activeCountryId = userData?.data?.activeCountry?.id;

    const isTranslationsPending =
        isTranslationsLoading || (isTranslationsFetching && !translations);
    const translationsLoaded =
        !!translations && !!activeLanguage && !isTranslationsPending;
    const isUserPending =
        userData.isLoading ||
        (userData.isFetching && userData.data === undefined);

    return {
        translationsLoaded,
        t,
        translations,
        activeLanguage,
        activeCountryId,
        userData,
        communicationEmail: userData?.data?.communicationEmail ?? null,
        isUserPending,
    };
};
